var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDinIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9857 20.7347C20.9857 15.589 16.7889 11.4258 11.6199 11.4258C6.45096 11.4258 2.24609 15.589 2.24609 20.7347",
    fill: "#FFDD02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9857 20.7347C20.9857 15.589 16.7889 11.4258 11.6199 11.4258C6.45096 11.4258 2.24609 15.589 2.24609 20.7347",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1639 11.53C10.1639 11.53 9.77502 8.95312 11.5898 8.95312C13.4046 8.95312 12.9752 11.4172 12.9752 11.4172",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H22",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99074 6.16178C7.99074 6.16178 8.49306 5.59004 8.49306 4.64787C8.49306 3.72986 7.59375 3.28697 7.59375 2.37701C7.59375 1.52343 8.32292 1 8.32292 1",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5415 6.16178C11.5415 6.16178 12.0438 5.59004 12.0438 4.64787C12.0438 3.72986 11.1445 3.28697 11.1445 2.37701C11.1445 1.52343 11.8737 1 11.8737 1",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0962 6.16178C15.0962 6.16178 15.5985 5.59004 15.5985 4.64787C15.5985 3.72986 14.6992 3.28697 14.6992 2.37701C14.6992 1.52343 15.4284 1 15.4284 1",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDinIn);
export default __webpack_public_path__ + "static/media/icon-din_in.c5bc7306.svg";
export { ForwardRef as ReactComponent };